/**
 * Catalogue order: aanmaakdatum in Propeller, nieuw -> oud (Menno, EXAMS-138,
 * 18-08-2026). There is no sort control in the UI, so this is what every
 * catalogue request gets unless a `?sort=` in the URL parses into something else.
 */
export const DEFAULT_SORT = 'created_desc'

const SORT_FIELDS: Record<string, string> = {
  price: 'PRICE',
  name: 'NAME',
  shortname: 'SHORT_NAME',
  created: 'CREATED_AT'
}

export interface ProductSort {
  field: string
  order: 'asc' | 'desc'
}

/** `price_asc` -> `[{ field: 'PRICE', order: 'asc' }]`; unsupported -> `[]`. */
export function constructSort (sortData: string): ProductSort[] {
  const parts = sortData.split(/_/gi)
  if (parts.length !== 2) { return [] }
  const field = SORT_FIELDS[parts[0].toLowerCase()]
  if (!field) { return [] }
  const order = parts[1].toLowerCase() === 'desc' ? 'desc' : 'asc'
  return [{ field, order }]
}
